/* eslint-disable sort-imports */ // <--- need this specific import order
import AppInput from "@/components/global/AppInput";
import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import App from "./App.vue";
import router from "@/router";
import * as Sentry from "@sentry/vue";
import store from "@/store";
import * as VeeValidate from "vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import PusherHandler from "@/components/PusherHandler.vue";
import VueFroala from "vue-froala-wysiwyg";
import "./validation-rules";

// Froala stuff
require("froala-editor/js/froala_editor.pkgd.min");
require("froala-editor/css/froala_editor.pkgd.min.css");
require("froala-editor/css/froala_style.min.css");

if (
  process.env.VUE_APP_SENTRY_ENVIRONMENT &&
  process.env.VUE_APP_SENTRY_DSN &&
  process.env.VUE_APP_SENTRY_ENVIRONMENT_WHITELIST &&
  process.env.VUE_APP_SENTRY_ENVIRONMENT_WHITELIST.split(",").includes(
    process.env.VUE_APP_SENTRY_ENVIRONMENT
  )
) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
    ignoreErrors: [
      "NavigationDuplicated"
    ]
  });
}

Vue.config.productionTip = false;

Vue.component("PusherHandler", PusherHandler);

Vue.use(VueFroala);

Vue.use(VeeValidate);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: "places"
  }
});

Vue.component("AppInput", AppInput);

new Vue({
  ...App,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
